// extracted by mini-css-extract-plugin
module.exports = {"shadowBox":"style_shadowBox__21D2i","spinning":"style_spinning__z0Uxn"};